(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[29257],{

/***/ 29257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ AutoWarrantyMakers; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88737);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78418);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36150);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_5__);






function AutoWarrantyMakers() {
    const { autoWarrantyMakers  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_1__/* .useDomainContext */ .w)();
    const year = new Date().getFullYear();
    const { query  } = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const queryString = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_4__/* .gettingQueriesAsString */ .r)(query, "start", [
        "genericRoute",
        "keyword",
        "replaceKeyword", 
    ]);
    const getMakerNameForUrl = (value)=>{
        return value.trim().toLowerCase().replace(/ /g, "-");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: autoWarrantyMakers && autoWarrantyMakers.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
            className: "lg:mb-[170px] mb-[100px] lg:mt-[100px] mt-[50px] ",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                    className: "text-[#424242] lg:text-[40px] text-3xl text-center",
                    children: [
                        "Best Car Make in the United States for ",
                        year
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex flex-wrap mt-7 mx-auto ",
                    children: autoWarrantyMakers.map((maker)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-[50%] sm:w-[32%] lg:w-[20%] flex justify-center mt-7 ",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: `/generic/reliable-protection-for-your-${getMakerNameForUrl(maker.value)}?replaceKeyword=true${queryString ? `${queryString.startsWith("&") ? queryString : `&${queryString}`}` : ""} `,
                                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default().beforeStyle)} text-[#3f7fea] text-lg    text-center hover:underline cursor-pointer`,
                                children: maker.label
                            })
                        }, maker.id))
                })
            ]
        })
    });
}


/***/ }),

/***/ 36150:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"beforeStyle":"style_beforeStyle__NeHaI"};

/***/ })

}]);